export type Lease = { wall: number; monotonic: number };
export function grantDeadline(seconds: number, started: number, now: number, wall: number): Lease {
  // Deduct the entire round trip and a safety margin, not just half the latency.
  const remaining = Math.max(0, Math.min(15, seconds) * 1000 - Math.max(0, now - started) - 1000);
  return { wall: wall + remaining, monotonic: now + remaining };
}
export function grantAlive(lease: Lease, monotonic: number, wall: number) {
  return monotonic < lease.monotonic && wall < lease.wall;
}
